import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useAppSelector } from '@store';
import Frs from '../../components/profit-loss/frs';

import cn from './profit-loss.module.css';

const ProfitLossFrs = () => {
  const { values, vatPercent } = useAppSelector(
    (state) => state.profitLoss.frs,
  );
  const { isLoading, errorList } = useOutletContext<{
    isLoading: boolean;
    errorList?: string;
  }>();

  useEffect(() => {
    let title = 'Profit-Loss FRS';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <div className={cn.profitLoss}>
      {errorList && (
        <div className={cn.reportsLoadingError}>
          <div className={cn.reportsLoadingErrorTitle}>Unable to load data</div>
          <div className={cn.reportsLoadingErrorText}>{errorList}</div>
        </div>
      )}
      {!errorList && (
        <Frs frs={values} isLoading={isLoading} vatPercent={vatPercent} />
      )}
    </div>
  );
};

export default ProfitLossFrs;
